<template>
  <div class="side-frame-success">
    <span style="font-size: 14px; color: #606266">
      {{ $l('table_label_sku_product_list') || 'SKU产品列表' }}
    </span>
    <div style="display: inline-block;" v-if="!disabled">
      <el-divider direction="vertical"></el-divider>
      <el-button
        v-if="allow('SK')"
        size="small"
        type="primary"
        icon="el-icon-plus"
        plain
        @click="$emit('openEdit', { type: 'add' })"
      >
        {{ $l('INDEX.btn_add') || '新增' }}
      </el-button>
      <el-button
        v-if="allow('SC')"
        size="small"
        class="ml-2"
        type="success"
        icon="el-icon-plus"
        plain
        @click="$emit('chooseSku')"
      >
        {{ $l('INDEX.table_label_Selectexistingsku') || '选择已有Sku' }}
      </el-button>
      <el-badge
        v-if="allow('SF')"
        :value="checkedRowCount"
        style="margin-bottom: 1px;"
      >
        <el-button
          v-if="allow('SF')"
          size="small"
          class="ml-2"
          type="success"
          :disabled="!checkedRowCount"
          plain
          @click="$emit('fullMember')"
        >
          {{ $l('btn_full_member') || '转正产品' }}
        </el-button>
      </el-badge>
      <el-badge
        v-if="allow('SR')"
        :value="checkedRowCount"
        style="margin-bottom: 1px;"
      >
        <el-button
          v-if="allow('SR')"
          size="small"
          class="ml-3"
          type="danger"
          :disabled="!checkedRowCount"
          plain
          @click="$emit('remove')"
        >
          {{ $l('INDEX.btn_remove') || '移除' }}
        </el-button>
      </el-badge>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    checkedRowCount: { type: Number, default: 0 },
  },
}
</script>
